import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from '@/services/instance'

export default class StdClassDataBatch {
  // 在线填报-提交
  static async submit(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/StdClassDataBatch/submit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 在线填报汇总确认-获取class列表
  static async getQueryCalss(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassDataBatch/get_query_calss?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 在线填报汇总-获取列表数据
  static async getList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassDataBatch/get?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 未完成-审批状态改变
  static async updateApprovestatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassDataBatch/update_approvestatus', payload)
    )
    return Callback(err, res)
  }
  // 在线填报质控-获取总数
  static async getTotal() {
    const [err, res] = await To(wizStandardInstance.get('/api/std/StdClassDataBatch/get_title'))
    return Callback(err, res)
  }
  // 未完成-往对应表里写数据
  static async writeDataInTable(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/StdClassDataBatch/insert_assessment?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 在线填报质控-获取sql具象化
  static async getSqlJson(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassDataBatch/get_sql_json?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 实体明细-修改审批状态
  static async changeStatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.patch(
        `/api/EntityDetailDataAuditing/data_auditing?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 未完成-审核对象-获取两个列表(实体明细审批)
  static async getAuditingList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/EntityDetailDataAuditing/data_auditing?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 实体明细-编辑
  static async updateDataDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/EntityDetailDataAuditing/data_auditing', payload)
    )
    return Callback(err, res)
  }
  // 数据采集错误日志
  static async getAcquisitionErrorLog(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/AcquisitionErrorLog?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getDataReceptionList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdStandard?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取错误信息
  static async getErrorDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/th_get_check_detail_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取整改记录
  static async getRRecords(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/th_get_rectification_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取错误数
  static async getDataReceptionDataList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/table-latest-task-run-result?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 异常数据确认
  static async abnormalDataConfirm(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataQualityTaskWhiteList/save_white_list', payload)
    )
    return Callback(err, res)
  }
  // 数据整改-异常数据确认
  static async getErrorData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataQualityCheckResult/dynamic-table-data-with-excepiton-info?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 数据审批-异常数据
  static async getDataError(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdDataStagingArea/dynamic-table-data-with-excepiton-info?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 提交错误修改信息
  static async submitEorrDetailForReview(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/StdDataQualityCheckResult/create-rectification-record',
        payload
      )
    )
    return Callback(err, res)
  }
  // 导出动态表错误数
  static async exportData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `api/std/StdDataQualityCheckResult/export-dynamic-table-error-data?${qs.stringify(
          payload
        )}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 修改整改状态
  static async updateStatus(id, payload) {
    const [err, res] = await To(
      wizStandardInstance.put(
        `/api/std/StdDataQualityCheckResult/handle-check-result/${id}`,
        payload,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      )
    )
    return Callback(err, res)
  }
}
